import type { PDFReaderOptions } from "@pdfking/renderer-api"
import { ImageToPdf } from "@pdfking/renderer-default"
import type { Bytes } from "@pdfking/tfunc"
import { IterableToArray, ToBlob } from "@pdfking/tfunc"

import { EngineError } from "../errors/EngineError"
import { FileContentType } from "../methods/FileContentType"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"
import { ErrorName } from "../types/errors/ErrorName"
import { ContentType } from "../types/files/ContentType"
import type { VirtualFile } from "../types/files/VirtualFile"
import type { TrackingCallback } from "../types/tasks/tracking/TrackingCallback"
import { RequestBlob } from "./RequestBlob"

export const CastPDFReaderOptions = async (
  engine: PdfEngine,
  options: PdfEngineOptions,
  file: VirtualFile,
  emit: TrackingCallback
): Promise<PDFReaderOptions> => {
  const { stream, size } = await RequestBlob(engine, file, emit)
  const type = FileContentType(file)

  switch (type) {
    case ContentType.PDF:
      return { stream, size }
    case ContentType.PNG:
    case ContentType.JPEG:
      const blob = await IterableToArray(stream)
        .then(ToBlob)
        .then(b => ImageToPdf(b, options.image_resolution))

      return { stream: [blob], size: blob.size as Bytes }
    default:
      throw EngineError(ErrorName.FILE_NOT_PDF)
  }
}
